module.exports = __webpack_public_path__ + "img/shopify-logo-2018.330eeb7e.svg";